import { enableStaticRendering } from "mobx-react-lite";
import { usersService, eventsService } from "@/modules/_core/services";
import { AuthStore } from "./authStore";
import { EventStore } from "./eventStore";

// there is no window object on the server
enableStaticRendering(typeof window === "undefined");

export const authStore = new AuthStore(usersService);
export const eventStore = new EventStore(eventsService);
